import React, { createContext, useState } from "react";
import GameInjector from "../screens/Game/GameInjector";

export const GameContext = createContext();

const GameContextProvider = ({children}) => {

    const [params, setParams] = useState({});

    function show( params ){ setParams( params ) }
    function hide(){ setParams( false ) }

    function onExit(){
        let cachedCallback = params.onCloseCallback;
        hide();
        cachedCallback?.();
    }

    return (
        <>
        {params.gameKey && <GameInjector gameKey={params.gameKey} onExitCallback={onExit}/>}
        { !params.clear && 
            <GameContext.Provider value={{show, hide}}> 
                {children} 
            </GameContext.Provider>
        }
        </>
    )

};

export default GameContextProvider;